"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const customerEmailTemplateValues_1 = __importStar(require("@powerednow/shared/constants/customerEmailTemplateValues"));
const constants_1 = require("@powerednow/shared/constants");
const complexData_1 = __importDefault(require("@powerednow/complexData/complexData"));
const entity_1 = __importStar(require("./entity"));
const modelProperties_1 = __importDefault(require("./modelProperties"));
const modelLookup_1 = require("../modelLookup");
// eslint-disable-next-line no-redeclare
class MessageRecipient extends complexData_1.default {
    static get allowedAssociations() {
        return {
            message: {
                key: 'customerMessage',
                instance: (0, modelLookup_1.complexFindModel)('CustomerMessage'),
                single: true,
                condition: {
                    id: this.Entity.getForeignFieldSymbols().message_id,
                },
            },
            messageTemplate: {
                key: 'messageTemplate',
                instance: (0, modelLookup_1.complexFindModel)('MessageTemplate'),
                single: true,
                condition: {
                    id: this.Entity.getForeignFieldSymbols().message_template_id,
                },
            },
            contact: {
                key: 'contact',
                instance: (0, modelLookup_1.complexFindModel)('Contact'),
                single: true,
                condition: {
                    id: this.Entity.getForeignFieldSymbols().contact_id,
                },
            },
            company: {
                instance: (0, modelLookup_1.complexFindModel)('Company'),
                key: 'company',
                single: true,
                cascadeDelete: false,
                condition: {
                    id: this.Entity.getFieldSymbols().company_id,
                },
            },
        };
    }
    getChannelType() {
        return customerEmailTemplateValues_1.ContactMethodTypeMap[this.data.contactmethodtype_id];
    }
    setTemplateData(data) {
        this.data.templateData = {
            ...data,
        };
    }
    async getTemplateValuesForRendering() {
        if (this.data.subject !== '' || this.data.message !== '') {
            const { subject, message } = this.data;
            return { subject, message };
        }
        return this.getTemplateValues();
    }
    async getTemplateValues() {
        const template = await this.getMessageTemplate();
        if (template) {
            return {
                subject: template.data.subject,
                message: template.data.message,
            };
        }
        const content = await this.getDefaultContent();
        return {
            subject: content.SUBJECT?.TEXT,
            message: content.BODY?.TEXT,
        };
    }
    async getButtonText(renderer) {
        const content = await this.getDefaultContent();
        const combinedTemplateData = await this.getTemplateDataForRendering();
        if ((content.HIDE_ACTION && !combinedTemplateData.canUsePortal)
            || (content.HIDE_ACTION && !combinedTemplateData.isMainContact && !combinedTemplateData.canSiteContactAccessPreviousMessages)) {
            return '';
        }
        return content?.BODY?.BUTTON_TEXT ? renderer(content.BODY.BUTTON_TEXT, combinedTemplateData) : '';
    }
    getStatusCategory(statusId = this.data.status) {
        const map = {
            [entity_1.DELIVERY_STATUS_CATEGORY.process_failed]: [
                constants_1.MESSAGES.DELIVERY_STATUS.process_failed,
            ],
            [entity_1.DELIVERY_STATUS_CATEGORY.processed]: [
                constants_1.MESSAGES.DELIVERY_STATUS.processed,
            ],
            [entity_1.DELIVERY_STATUS_CATEGORY.sent]: [
                constants_1.MESSAGES.DELIVERY_STATUS.send,
                constants_1.MESSAGES.DELIVERY_STATUS.sent,
                constants_1.MESSAGES.DELIVERY_STATUS.delivered,
            ],
            [entity_1.DELIVERY_STATUS_CATEGORY.rejected]: [
                constants_1.MESSAGES.DELIVERY_STATUS.bounce,
                constants_1.MESSAGES.DELIVERY_STATUS.dropped,
                constants_1.MESSAGES.DELIVERY_STATUS.deferral,
                constants_1.MESSAGES.DELIVERY_STATUS.hard_bounce,
                constants_1.MESSAGES.DELIVERY_STATUS.soft_bounce,
                constants_1.MESSAGES.DELIVERY_STATUS.failed,
                constants_1.MESSAGES.DELIVERY_STATUS.reject,
            ],
            [entity_1.DELIVERY_STATUS_CATEGORY.open]: [
                constants_1.MESSAGES.DELIVERY_STATUS.read,
                constants_1.MESSAGES.DELIVERY_STATUS.open,
            ],
            [entity_1.DELIVERY_STATUS_CATEGORY.click]: [
                constants_1.MESSAGES.DELIVERY_STATUS.click,
            ],
            [entity_1.DELIVERY_STATUS_CATEGORY.reported]: [
                constants_1.MESSAGES.DELIVERY_STATUS.spam,
                constants_1.MESSAGES.DELIVERY_STATUS.report_span,
                constants_1.MESSAGES.DELIVERY_STATUS.unsubscribe,
                constants_1.MESSAGES.DELIVERY_STATUS.unsub,
            ],
            [entity_1.DELIVERY_STATUS_CATEGORY.deferred]: [
                constants_1.MESSAGES.DELIVERY_STATUS.deferred,
            ],
        };
        let foundKey;
        Object.keys(map).forEach(key => {
            if (map[key].includes(statusId)) {
                foundKey = key;
            }
        });
        return foundKey;
    }
    async getDefaultContent() {
        const message = await this.getMessage();
        const content = message.findDefaultContentById();
        return content[customerEmailTemplateValues_1.ContactMethodTypeMap[this.data.contactmethodtype_id]] || content.EMAIL;
    }
    async getLocaleTemplateData() {
        const company = await this.getCompany();
        const companyAddress = await company.getCompanyAddress();
        const { city } = companyAddress.data;
        const country = await companyAddress.getCountry();
        return { city, countryCode: country.data.code };
    }
    async getRenderedContent(renderer) {
        const content = await this.getTemplateValuesForRendering();
        const combinedTemplateData = await this.getTemplateDataForRendering();
        return {
            message: content.message ? renderer(content.message, combinedTemplateData) : '',
            subject: content.subject ? renderer(content.subject, combinedTemplateData) : '',
        };
    }
    async getTemplateDataForRendering() {
        const message = await this.getMessage();
        const { templateData } = this.data;
        //
        // Some older messages  may not have previousValues or documenturl template data. Lets make sure we are not
        // crashing the app if we try to render a template with no data.
        //
        if (!templateData.previousValues) {
            templateData.previousValues = {};
        }
        if (!templateData.documenturl) {
            templateData.documenturl = '';
        }
        return {
            ...templateData,
            ...await message.getNotificationTemplateData(templateData),
        };
    }
    async isDocumentReminder() {
        const message = await this.getMessage();
        return [
            customerEmailTemplateValues_1.default.QUOTE_REMINDER.ID,
            customerEmailTemplateValues_1.default.QUOTE_REMINDER_HARSH.ID,
            customerEmailTemplateValues_1.default.QUOTE_REMINDER_GENTLE.ID,
            customerEmailTemplateValues_1.default.INVOICE_REMINDER.ID,
            customerEmailTemplateValues_1.default.INVOICE_REMINDER_GENTLE.ID,
            customerEmailTemplateValues_1.default.INVOICE_REMINDER_HARSH.ID,
        ].includes(message.data.type);
    }
    async getMessageTypeName() {
        const message = await this.getMessage();
        return message.getMessageTypeString();
    }
}
MessageRecipient.Entity = entity_1.default;
MessageRecipient.modelProperties = modelProperties_1.default;
exports.default = MessageRecipient;
//# sourceMappingURL=../../../../src/models/messageRecipient/index.js.map